export const modalEvents = {
    openModal(event, payload: {id: string}, backdropClass: string) {

        let modal = document.querySelector<HTMLElement>('#' + payload.id);

        if (modal === null) {
            return;
        }

        modal!.style.display = 'block';

        let parentEl = document.querySelector('body');
        let backdrop = document.createElement('div');

        backdrop.classList.add(backdropClass);
        backdrop.classList.add('fade-in-backdrop');

        if (parentEl) {
            parentEl.classList.add('body-overflow');
            parentEl.insertAdjacentElement('beforeend', backdrop);
        }
    },

    openModalAdminCalendar(payload): void {

        let modal = document.querySelector<HTMLElement>('#' + payload.id);

        if (modal === null) {
            return;
        }

        modal!.style.display = 'block';

        let parentEl = document.querySelector('body');
        let backdrop = document.createElement('div');

        backdrop.classList.add(payload.backdrop);
        backdrop.classList.add('fade-in-backdrop');
        if (parentEl) {
            parentEl.classList.add(payload.bodyOverflow);
            parentEl.insertAdjacentElement('beforeend', backdrop);
        }
    },


    closeModal(payload): void {
        let parentEl = document.querySelector<HTMLElement>('body');
        let backdrop = document.querySelector('.' + payload.backdrop);

        let modal = document.querySelector<HTMLElement>('#' + payload.id);
        modal!.style.display = 'none';

        parentEl!.classList.remove(payload.bodyOverflow);
        if (backdrop && parentEl) {
            backdrop.classList.remove('fade-in-backdrop');
            backdrop.classList.add('fade-out-backdrop');

            backdrop.addEventListener('animationend', () => {
                if (backdrop && parentEl) {
                    parentEl.removeChild(backdrop);
                }
            })
        }
    },
}